import { Outlet } from "react-router-dom";
// import HeaderMenu from "./HeaderMenu/HeaderMenu";
import Footer from "./Footer/Footer";

function RootLayout() {
  return (
    <div>
      {/* <HeaderMenu /> */}

      <div>
        <Outlet />
      </div>

      <Footer />
    </div>
  );
}

export default RootLayout;
